import { render, staticRenderFns } from "./OilDeviceList.vue?vue&type=template&id=367fdc28&scoped=true"
import script from "./OilDeviceList.vue?vue&type=script&lang=js"
export * from "./OilDeviceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367fdc28",
  null
  
)

export default component.exports